import {IStorageService} from './storage.service.interface';
import {ILoggerService} from '../logger/logger.service.interface';

export class InMemoryLocalStorageService implements IStorageService {

  constructor(private _logger: ILoggerService) {

  }

  _localStorageData = {};
  _cookies = {};


  setItem(key:string, value:any): void {
    this._localStorageData[key] = value;
  }

  getItem(key: string): any {
    return this._localStorageData[key];
  }

  removeItem(key: string): void {
    delete this._localStorageData[key];
  }

  setJson(key: string, value: object): void {
    this._localStorageData[key] = JSON.stringify(value);
  }

  getJson(key: string): any {
    var value = this.getItem(key);
    if(!value) {
      return value;
    }

    return JSON.parse(value);
  }

  createCookie(name: string, value: string): void {
    this._cookies[name] = value;
  }

  createDomainCookie(name: string, value: string): void {
    this._cookies[name] = value;
  }


  getCookie(name: string) {
    return this._cookies[name];
  }

  removeCookie(name: string): void {
    try {
      if(this._cookies[name]) {
        delete this._cookies[name];
      }
    } catch (err) {
      this._logger.error('InMemoryLocalStorageService.removeCookie failed', err);
    }
  }
}
